/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * Pagination CSS
 */
export const styles = css`
  :host {
  }

  :host([disabled]) {
    cursor: not-allowed;
  }

  :host([disabled]) .pagination-wrapper,
  :host([disabled]) .pagination-wrapper.mini {
    pointer-events: none;
  }

  :host([disabled]) .range-text,
  :host([disabled]) .page-size-label,
  :host([disabled]) .mini-showing-label,
  :host([disabled]) .mini-of-label {
    color: var(--nile-colors-neutral-500, var(--ng-colors-text-disabled));
  }

  .pagination-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--nile-spacing-spacing-md, var(--ng-spacing-md)) var(--nile-spacing-spacing-lg, var(--ng-spacing-lg)) ;
  }

 
  .pagination-wrapper.mini .pager-container {
    flex-direction: row;
    align-items: center;
    gap: var(--nile-spacing-spacing-md, var(--ng-spacing-md));
    margin-right: var(--nile-spacing-spacing-xl, var(--ng-spacing-xl)); 
  }

  .pagination-wrapper.mini .range-text {
    margin-right: var(--nile-spacing-spacing-md, var(--ng-spacing-md));
    font-size: var(--nile-font-size-small, var(--ng-font-size-text-sm));
    color: var(--nile-colors-dark-900, var( --ng-colors-text-primary-900));
    font-feature-settings: 'liga' off, 'clig' off;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
  }

  .pagination-wrapper.mini {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: var(--nile-spacing-spacing-md, var(--ng-spacing-md)) var(--nile-spacing-spacing-lg, var(--ng-spacing-lg));
  }

  .mini-showing-label,
  .mini-of-label {
    font-size: var(--nile-font-size-small, var(--ng-font-size-text-sm));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-primary-900));
    font-feature-settings: 'liga' off, 'clig' off;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
    white-space: nowrap;
    line-height: 32px;
  }

  .mini-page-dropdown nile-menu {
    overflow-y: auto;
    padding: var(--nile-spacing-spacing-lg, var(--ng-spacing-lg)) var(--nile-spacing-spacing-none, var(--ng-spacing-none));
    box-shadow: 0px 4px 8px 0px rgba(119, 125, 130, 0.15);
  }

  .mini-scroll-wrapper {
    max-height: 164px;
    overflow-y: auto;
    width: 60px;
  }

  nile-button.mini-page-btn::part(base) {
    min-width: auto;
    height: 10px;
    padding: 0px 4px;
    gap: 2px;
    border: none ;
    box-shadow: none ;
    background: transparent ;
    font-family: var(--nile-font-family-medium, var(--ng-font-family-body));
    font-size: var(--nile-font-size-small, var(--ng-font-size-text-xs));
    font-weight: var(--nile-font-weight-semibold, var(--ng-font-weight-semibold));
  }

  nile-button.mini-page-btn::part(base):hover,
  nile-button.mini-page-btn::part(base):active {
    min-width: auto;
    height: 10px;
    padding: 0px 4px;
    gap: 2px;
    border: none ;
    background: transparent ;
  }

  .mini-page-dropdown {
    display: inline-flex;
    align-items: center;
  }

  nile-button.mini-prev-button::part(base),
  nile-button.mini-next-button::part(base) {
    border: none ;
  }

  nile-button.mini-prev-button::part(base):hover,
  nile-button.mini-next-button::part(base):hover {
    border: none ;
  }

  nile-button.mini-prev-button::part(base):active,
  nile-button.mini-next-button::part(base):active {
    border: none ;
  }

  .mini-page-dropdown .chevron {
    transition: transform 0.2s;
  }

  .mini-page-dropdown .mini-page-btn.open .chevron {
    transform: rotate(180deg);
  }

  .mini-nav {
    display: inline-flex;
    align-items: center;
    margin-left: var(--nile-spacing-spacing-none, var(--ng-spacing-none));
  }

  .mini-pagination {
    display: inline-flex;
    align-items: center;
    gap: 0;
    list-style: none;
    margin: 0;
    padding: 0;
  }

 
  .pagination-wrapper.compact {
    min-width: 324px;
    justify-content: space-between;
  }



.pagination-wrapper.compact .range-text {
  margin-right: var(--nile-spacing-spacing-md, var(--ng-spacing-md));
  white-space: nowrap;
}


.pagination-wrapper.compact .pager-container {
  gap: var(--nile-spacing-spacing-md, var(--ng-spacing-md));
}


  .pagination-wrapper.compact .pager-container {
    display: flex;
    align-items: center;
    gap: var(--nile-spacing-spacing-md, var(--ng-spacing-md));
  }

  .pagination-wrapper.compact .page-size-dropdown ::part(base) {
    min-width: 32px;
    height: 32px;
    padding: 0 6px;
  }

  .pagination-wrapper.compact .page-size-dropdown .chevron {
    transition: transform 0.2s;
  }
  .pagination-wrapper.compact .page-size-dropdown .open .chevron {
    transform: rotate(180deg);
  }

  .pagination-wrapper.compact ul.pagination:not(.compact-pagination) {
    display: none;
  }

  .compact-pagination {
    display: flex;
    align-items: center;
    gap: var(--nile-spacing-spacing-xs, var(--ng-spacing-xs));
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .page-dropdown .current-page-btn {
    padding: 2px;
    font-size: var(--nile-font-size-small, var(--ng-font-weight-regular));
  }

  nile-button.current-page-btn::part(base){
    min-width: 51px;
  }

  nile-button.current-page-btn::part(base):active {
  min-width: 51px;
}

  .pager-container {
    display: flex;
    align-items: center;
    gap: var(--nile-spacing-spacing-3xl, var(--ng-spacing-3xl));
  }

.pagination-wrapper.compact .pager-container {
  gap: var(--nile-spacing-xxs, var(--ng-spacing-xxs)) ;
}

  .range-text {
    font-size: var(--nile-font-size-small,  var(--ng-font-weight-regular));
    color: var(--nile-colors-dark-900,var( --ng-colors-text-primary-900) );
    white-space: nowrap;
  }

  .page-size-select {
    display: inline-flex;
    align-items: center;
  }

  ul.pagination {
    display: flex;
    list-style: none;
    padding: var(--nile-spacing-spacing-none, var(--ng-spacing-none));
    margin: var(--nile-spacing-spacing-none, var(--ng-spacing-none));
    gap: var(--nile-radius-radius-xxs, var(--ng-radius-xxs));
  }

  ul.pagination li {
    margin: var(--nile-spacing-spacing-none, var(--ng-spacing-none));
  }

  .ellipsis-scroll-wrapper {
    max-height: 194px;
    overflow-y: auto;
    width: 66px;
  }
    .down-scroll-wrapper {
    max-height: 150px;
    overflow-y: auto;
    width: 60px;
  }


    .compact-scroll-wrapper {
    max-height: 160px;
    overflow-y: auto;
    width: 60px;
  }
  .compact-dropdown nile-menu {
    overflow-y: auto;
    padding: var(--nile-spacing-spacing-lg, var(--ng-spacing-lg)) var(--nile-spacing-spacing-none, var(--ng-spacing-none));
    box-shadow: 0px 4px 8px 0px rgba(119, 125, 130, 0.15);
  }
  
    .page-size-dropdown nile-menu {
    overflow-y: auto;
    padding: var(--nile-spacing-spacing-lg, var(--ng-spacing-lg)) var(--nile-spacing-spacing-none, var(--ng-spacing-none));
    box-shadow: 0px 4px 8px 0px rgba(119, 125, 130, 0.15);
  }

      .compact-scroll-wrapper1 {
    max-height: 164px;
    overflow-y: auto;
    width: 60px;
  }

  .compact-dropdown1 nile-menu {
    overflow-y: auto;
    padding: var(--nile-spacing-spacing-lg, var(--ng-spacing-lg)) var(--nile-spacing-spacing-none, var(--ng-spacing-none));
    box-shadow: 0px 4px 8px 0px rgba(119, 125, 130, 0.15);
  }
  
    .compact-dropdown1 nile-menu {
    overflow-y: auto;
    padding: var(--nile-spacing-spacing-lg, var(--ng-spacing-lg)) var(--nile-spacing-spacing-none, var(--ng-spacing-none));
    box-shadow: 0px 4px 8px 0px rgba(119, 125, 130, 0.15);
  }


  .ellipsis-dropdown nile-menu {
    overflow-y: auto;
    padding: var(--nile-spacing-spacing-lg, var(--ng-spacing-lg)) var(--nile-spacing-spacing-none, var(--ng-spacing-none));
    box-shadow: 0px 4px 8px 0px rgba(119, 125, 130, 0.15);
  }

  .page-size-menu {
    max-height: 144px;
    overflow-y: auto;
  }

.pagination-wrapper.fluid ul.pagination li:first-child {
  margin-right: var(--nile-spacing-spacing-xs, var(--ng-spacing-xs));
}
.pagination-wrapper.fluid ul.pagination li:last-child {
  margin-left: var(--nile-spacing-spacing-md, var(--ng-spacing-md));
}


  .page-size-label {
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
    color: var(--nile-colors-dark-500, var(--ng-colors-text-primary-500));
    margin-left: var(--nile-spacing-spacing-md, var(--ng-spacing-md));
    font-feature-settings: 'liga' off, 'clig' off;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular)); 
  }

  nile-button::part(base) {
    min-width: 32px;
    height: 32px;
    padding: 0px 6px;
    box-shadow: none;
  }
  
   nile-button.down::part(base) {
    border: 1px solid var(--nile-colors-neutral-500, var(--ng-colors-border-primary));
  }

  nile-button.down::part(base):active {
    border: 1px solid var(--nile-colors-neutral-500, var(--ng-colors-border-primary));
  }


  nile-button.current-page-btn::part(base) {
    border: 1px solid var(--nile-colors-neutral-500, var(--ng-colors-border-primary)); 
  }

  nile-button.current-page-btn::part(base):active {
    border: 1px solid var(--nile-colors-neutral-500, var(--ng-colors-border-primary));
  }
  
  nile-button::part(base):active {
    min-width: 32px;
    height: 32px;
    padding: 0px 6px;
    box-shadow: none;
    border: none;
  }

  nile-button.down::part(base) {
    min-width: 62px;
  }

  nile-button.compactbtn:part(base){
    background-color: red;
  }
  .page-size-dropdown .chevron {
    transition: transform 0.2s;
  }
  .page-size-dropdown .open .chevron {
    transform: rotate(180deg);
  }
 
  .pagination-wrapper.compact .compact-dropdown .chevron,
  .pagination-wrapper.compact .compact-dropdown1 .chevron {
    transition: transform 0.2s;
  }
  .pagination-wrapper.compact .compact-dropdown .down.open .chevron,
  .pagination-wrapper.compact .compact-dropdown1 .current-page-btn.open .chevron {
    transform: rotate(180deg);
  }

  .prev-button::part(base) {
    border: 1px solid var(--nile-colors-neutral-500, var(--ng-colors-border-primary));
  }

  .next-button::part(base) {
    border: 1px solid var(--nile-colors-neutral-500, var(--ng-colors-border-primary));
  }

  .prev-button[disabled]::part(base) {
    border: 1px solid var(--nile-colors-neutral-400, var(--ng-colors-border-disabled));
  }
  .next-button[disabled]::part(base) {
    border: 1px solid var(--nile-colors-neutral-400, var(--ng-colors-border-disabled));
  }
`;

export default [styles];
